import { memo, FC, useMemo } from 'react';

import { MassMessageRecipient, RecipientType } from 'models';

import { RecipientsOrganizationIcon, PersonIcon } from 'components/icons';

import { useStyles } from './style';

interface RecipientProps {
  recipient: MassMessageRecipient;
}

const Recipient: FC<RecipientProps> = ({ recipient }) => {
  const classes = useStyles();

  const Icon = useMemo(() => {
    return recipient.Type === RecipientType.Organization
      ? RecipientsOrganizationIcon
      : PersonIcon;
  }, [recipient]);

  return (
    <div className={classes.row}>
      <Icon className={classes.icon} />
      <span className={classes.label}>{recipient.FullName}</span>
    </div>
  );
};

export default memo(Recipient);
